import React, {useEffect, useRef, useState} from "react";
import {ZedStage} from "./ZedStage";
import {SpokenLine, useSpeech} from "../../common/spokenLine";

export const ReceivingTransmission = () => {
    return (
        <video
            src="/ai-player.mp4"
            autoPlay
            loop
            muted
            playsInline
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                objectFit: 'cover',
                backgroundColor: 'black',
            }}
        />
    );
}

// The dialog is spoken by the server (server/games/ai/dialog_director.rb), which also turns Zed toward whoever
// each line is about; this shows it.
export const AiDialog = ({isControl = false, PlayerView, layout = 'zed', receiveEvents, clockDrift}) => {
    const [dialog, setDialog] = useState(null);
    const [characterOne, setCharacterOne] = useState();
    const [characterTwo, setCharacterTwo] = useState();
    const characterHighlightPosition = useRef(0);
    const speech = useSpeech(receiveEvents);

    useEffect(() => {
        if (!isControl) return;
        fetch('/dialog', {credentials: 'include'}).then(r => r.json()).then(d => setDialog(d.dialog || null)).catch(() => {});
    }, [isControl]);
    useEffect(() => receiveEvents && receiveEvents((data) => {
        if (data && 'dialog' in data) setDialog(data.dialog || null);
    }), [receiveEvents]);

    const sequence = (dialog && dialog.sequence) || [];
    const index = dialog ? dialog.index : 0;
    const characters = (dialog && dialog.characters) || [];
    const cast = (dialog && dialog.cast) || characters;
    const currentText = sequence[index];

    useEffect(() => {
        if (!characters.length) return;
        if (!currentText) return;

        const character = characters.find(character =>
            currentText.includes(character.name)
        );

        if(!character) {
            setCharacterOne(null);
            setCharacterTwo(null);
            return;
        };

        if(characterHighlightPosition.current === 0) {
            characterHighlightPosition.current = 1;
            setCharacterOne(character);
            setCharacterTwo(null);
        } else {
            setCharacterOne(null);
            characterHighlightPosition.current = 0;
            setCharacterTwo(character);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentText, characters.length]);

    if (!isControl) return PlayerView;
    if (!currentText) return null;

    const line = speech && speech.id === `dialog:line:${dialog.scene}:${index}` ? speech : null;
    if (layout === 'zed') {
        const named = (text) => text && characters.find(c => text.includes(c.name));
        const featured = named(currentText);
        const filed = new Set(sequence.slice(0, index).map(named).filter(c => c && (!featured || c.name !== featured.name)).map(c => c.name));
        return <ZedStage cast={cast} featured={featured} filed={filed} subtitle={<SpokenLine speech={line} clockDrift={clockDrift} style={{fontSize: 58}}/>}/>;
    }

    const getCharacterHighlight = (position, character) => {
        return <div style={{
            position: 'absolute',
            [position]: character ? 155 : -300,
            opacity: character ? 1 : 0,
            transition: 'all 300ms',
            top: 290,
            width: 340,
            height: 580,
            padding: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
        }}>
            <img src={character?.image_url} height={300} width={300}/>
            <div style={{fontSize: 40, paddingTop: 10}}>{character?.name}</div>
            <div style={{fontSize: 34, fontWeight: 'bold'}}>{character?.nickname}</div>
            <div style={{fontSize: 24}}>{character?.interesting_fact}</div>
        </div>;
    };

    return <>
        <div style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: '#000',
            zIndex: -1,
        }}/>
        <div style={{fontSize: 70, textAlign: 'center', width: '1500px', alignSelf: 'flex-start'}}>
            <SpokenLine speech={line} clockDrift={clockDrift}/>
        </div>
        {getCharacterHighlight('left', characterOne)}
        {getCharacterHighlight('right', characterTwo)}
    </>;
}